
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.49 4.49a8.5 8.5 0 1112.02 12.02A8.5 8.5 0 014.49 4.49zm6.01-1.073a7.083 7.083 0 100 14.166 7.083 7.083 0 000-14.166zm.367 3.228a.944.944 0 10-1.05 1.57.944.944 0 001.05-1.57zm-2.071 8.157a.63.63 0 00.445.184h2.518a.63.63 0 000-1.26h-.472a.157.157 0 01-.157-.157v-2.99a1.259 1.259 0 00-1.26-1.26h-.63a.63.63 0 100 1.26h.473a.157.157 0 01.157.157v2.833a.157.157 0 01-.157.158h-.472a.63.63 0 00-.445 1.075z","fill":"currentColor"}})])
          )
        }
      }
    